module.exports = __webpack_public_path__ + "static/media/onboard-step-3.98b46875.png";